import api from '../config/api';

const configuracionFotosPersonalService = {
  async obtenerConfiguracion(empresaId) {
    try {
      const response = await api.get(`/configuracion-fotos-personal/empresa/${empresaId}`);
      return response.data;
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Error al obtener configuración de fotos del personal',
      };
    }
  },

  async actualizarConfiguracion(empresaId, activo) {
    try {
      const response = await api.put(`/configuracion-fotos-personal/empresa/${empresaId}`, {
        activo: Boolean(activo),
      });
      return response.data;
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Error al actualizar configuración de fotos del personal',
        details: error.response?.data?.details,
      };
    }
  },

  async verificarEstado(empresaId) {
    try {
      const response = await api.get(`/configuracion-fotos-personal/empresa/${empresaId}/estado`);
      return response.data;
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Error al verificar estado de fotos del personal',
      };
    }
  },
};

export default configuracionFotosPersonalService;
